// this mutator is needed for deleteConversationItemParts
import './tryRemoveFromMailStoreItemsMutator';

import loadFolderForest from 'owa-mail-folder-forest-actions/lib/actions/loadFolderForest';
import { initializeAlwaysInCacheTableViews } from 'owa-mail-triage-local-updates/lib/actions/tableCache/alwaysInCacheTableViews';
import { loadDefaultTable } from 'owa-mail-table-loading-actions/lib/actions/loadDefaultTable';
import { initializeMailLayout } from 'owa-mail-layout';
import { conversationCache, mailStore } from 'owa-mail-store';
import deleteConversationItemParts from 'owa-mail-store-actions/lib/actions/deleteConversationItemParts';
import { verifyAndSetOptionValues } from 'owa-outlook-service-option-store';
import { getPrimeBootSettingsOptionsValues } from 'owa-session-store';
import { loadCommandBarActions } from 'owa-mail-commandbar-actions';
import { initializeCommandingViewMode } from 'owa-command-ribbon-store';
import { stashSessionData } from 'owa-session-data-stash';
import { SessionData } from 'owa-service/lib/types/SessionData';

export default function initializeMailModuleState(sessionData?: SessionData | undefined) {
    if (sessionData) {
        stashSessionData(sessionData);
    }

    // Passing a delegate here as the delete callback to allow deleteConversationItemParts to be fully loaded by webpack.
    conversationCache.initialize(mailStore.conversations, key => {
        deleteConversationItemParts(key);
    });

    const options = getPrimeBootSettingsOptionsValues();
    verifyAndSetOptionValues(options);

    initializeCommandingViewMode(options);

    loadCommandBarActions();

    initializeAlwaysInCacheTableViews();

    loadDefaultTable();

    loadFolderForest();

    initializeMailLayout();
}
